if (typeof RelatedProducts === 'undefined') {
    class RelatedProducts extends HTMLElement {
        constructor() {
            super();
            this.isLoaded = false;
            this.swiper = null;
        }

        connectedCallback() {
            if (this.isLoaded) return;
            this.isLoaded = true;

            const url = this.dataset.url;
            if (!url) {
                this.initializeSwiper();
                return;
            }

            fetch(url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const fetched = html.querySelector('[data-related-products-api]');

                    if (fetched && fetched.innerHTML.trim().length) {
                        const wrapper = this.querySelector('.swiper-wrapper');
                        if (wrapper) {
                            wrapper.querySelectorAll('.skeleton-list-item').forEach((el) => el.remove());

                            const slides = fetched.querySelectorAll(':scope > .swiper-slide');
                            const fragment = document.createDocumentFragment();
                            slides.forEach((slide) => {
                                fragment.appendChild(slide);
                            });
                            wrapper.appendChild(fragment);
                        }
                    }
                })
                .catch((e) => {
                    console.error('Error fetching product recommendations:', e);
                })
                .finally(() => {
                    this.initializeSwiper();
                });
        }

        initializeSwiper() {
            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            // Wait for Swiper to be available
            whenReady('Swiper', () => {
                try {
                    const sliderOptions = {
                        loop: false,
                        slidesPerView: "auto",
                        spaceBetween: 0,
                        watchSlidesProgress: true,
                        mousewheel: {
                            forceToAxis: true
                        },
                        navigation: {
                            nextEl: this.closest(".shopify-section").querySelector('.swiper-next'),
                            prevEl: this.closest(".shopify-section").querySelector('.swiper-prev'),
                        },
                        a11y: true,
                        breakpoints: {
                            768: {
                                slidesPerView: 2
                            }
                        },
                        modules: [window.Swiper.Mousewheel, window.Swiper.Navigation, window.Swiper.A11y],
                    };
                     
                    this.swiper = new window.Swiper(swiperContainer, sliderOptions);
                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {
            // Clean up swiper 
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }
    }

    if (!window.customElements.get('related-products')) {
        window.customElements.define('related-products', RelatedProducts);
    }
}

